import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'out-select',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
})
export class SelectComponent implements OnInit, OnDestroy {
  @Input() id!: string;
  @Input() name!: string;
  @Input() label!: string;
  @Input() inlinePlaceholder?: string;
  @Input() required = false;
  @Input() validation?: string | object;
  @Input() value!: string | number | null;
  @Input() items: Array<{
    value: string | number;
    label: string;
    disabled?: boolean;
  }> = [];
  @Input() multiSelect = false;
  @Input() errorMessage = '';
  @Input() control!: FormControl;
  @Input() placeholder!: string | 'Select an option';
  @Input() selectClass = '';

  private subscription!: Subscription;

  @Output() valueChange = new EventEmitter<string | number>();

  ngOnInit() {
    if (this.control) {
      this.subscription = this.control.valueChanges.subscribe((value) => {
        this.valueChange.emit(value);
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  get classes() {
    return `${this.selectClass} disabled:opacity-50 w-full disbaled:pointer-events-none  px-2 py-3`;
  }

  hasError(): boolean {
    return this.control && this.control.invalid && this.control.touched;
  }

  markAsTouched(): void {
    if (this.control) {
      this.control.markAsTouched();
      if (this.control.value === '' || this.control.value === null) {
        this.control.setErrors({ required: true });
      } else {
        this.control.setErrors(null);
      }
      this.control.updateValueAndValidity();
    }
  }
}
